<template>
    <div class="send-emails-container">
        <div class="templates-container">
            <div class="search-container" v-if="type=='templates'">
              <div class="search-icon">
                  <svg  v-if="searchInput == ''" id="Group_10091" data-name="Group 10091" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20.933" height="20.934" viewBox="0 0 20.933 20.934">
                    <defs>
                        <clipPath id="clip-path">
                        <rect id="Rectangle_2331" data-name="Rectangle 2331" width="20.933" height="20.934" fill="#28345c"/>
                        </clipPath>
                    </defs>
                    <g id="Group_7557" data-name="Group 7557" >
                        <path id="Path_6095" data-name="Path 6095" d="M.555,20.382a1.893,1.893,0,0,1,0-2.677L6.2,12.057a7.785,7.785,0,0,1-.568-1.131A7.94,7.94,0,1,1,10.008,15.3a7.545,7.545,0,0,1-1.13-.567L3.229,20.382a1.9,1.9,0,0,1-2.674,0M8.527,3.467A6.324,6.324,0,1,0,13,1.616a6.323,6.323,0,0,0-4.47,1.851Z" transform="translate(0 0)" fill="#28345c"/>
                    </g>
                    </svg>
                    <div v-else class="remove" @click="searchInput = ''">
                        <span></span><span></span>
                    </div>
                </div>
              <input type="text" :placeholder="toLocal('generic.enter_name')" v-model="searchInput">
          </div>
            <div class="list" v-if="type=='templates'">
                <div 
                    class="template-item"
                    v-for="(template, index) in templates"
                    :key="template.id"
                >
                    <TemplateItem  
                        :item="template"
                        :selectedItem="selectedTemplate"
                        @selectItem="selectedTemplate=template"
                        @duplicateItem="duplicateTemplate"
                        @deleteItem="deleteTemplate(template)"
                    />
                </div>
            </div>
            <div class="sent-list" v-else>
                <div class="empty" v-if="sentEmailTemplateList.length == 0">
                    <span>
                        {{toLocal('generic.no_records')}}
                    </span>
                </div>
                <div class="dates">
                    <div class="date-item" v-for="(items, date) in sentDates" :key="date">
                        <span class="date">
                            {{ date }}
                        </span>
                        <div class="sent-template-container">

                            <div 
                                class="sent-template" 
                                v-for="item in items" :key="item.id"
                                :class="{active: selectedTemplate && (item.id == selectedTemplate.id)}"
                                @click="selectLog(item)"
                            >
                                <VTooltip v-if="item.id && typeof item.id == 'string' && item.id.includes('auto')" theme="users" class="tooltip-template-item-container"  :triggers="['hover']" :placement="'top'">
                                    <span class="name" >
                                        {{ item.name }}
                                        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.1786 0.902344H0.607143C0.446119 0.902344 0.291689 0.966311 0.177828 1.08017C0.0639666 1.19403 0 1.34846 0 1.50949V11.8309C0 12.153 0.127933 12.4618 0.355656 12.6895C0.583379 12.9173 0.892237 13.0452 1.21429 13.0452H14.5714C14.8935 13.0452 15.2023 12.9173 15.4301 12.6895C15.6578 12.4618 15.7857 12.153 15.7857 11.8309V1.50949C15.7857 1.34846 15.7217 1.19403 15.6079 1.08017C15.494 0.966311 15.3396 0.902344 15.1786 0.902344ZM13.6175 2.11663L7.89286 7.36462L2.16826 2.11663H13.6175ZM14.5714 11.8309H1.21429V2.88998L7.48228 8.63583C7.59429 8.73865 7.74081 8.7957 7.89286 8.7957C8.04491 8.7957 8.19143 8.73865 8.30344 8.63583L14.5714 2.88998V11.8309Z" fill="#333333"/>
                                            <path class="svg-triangle" d="M11.3332 6.57031L16.2406 14.4632H6.42569L11.3332 6.57031Z" fill="white"/>
                                            <path class="svg-letter" d="M11.4336 8.6875C11.4434 8.6875 11.4536 8.6888 11.4629 8.69141L11.4902 8.70312C11.4987 8.70834 11.5061 8.71541 11.5127 8.72266L11.5303 8.74707L14.2617 14.2109L14.2734 14.2637C14.2726 14.2819 14.2674 14.2999 14.2578 14.3154L14.2188 14.3525C14.2028 14.3614 14.1843 14.3662 14.166 14.3662L14.1367 14.3623L14.1104 14.3506C14.1018 14.3453 14.0936 14.3384 14.0869 14.3311L14.0703 14.3066L13.3271 12.8213L13.1895 12.5449H9.67871L9.54102 12.8213L8.79785 14.3066C8.79155 14.3192 8.78287 14.3308 8.77246 14.3398L8.73535 14.3604C8.72197 14.3648 8.70813 14.3672 8.69434 14.3662L8.6543 14.3545C8.64159 14.3481 8.63023 14.3396 8.62109 14.3291L8.60059 14.293C8.59605 14.2793 8.59367 14.265 8.59473 14.251L8.60645 14.2109L11.3379 8.74707C11.3423 8.73834 11.348 8.72983 11.3545 8.72266L11.3779 8.70312C11.3946 8.69287 11.414 8.68759 11.4336 8.6875ZM10.9873 9.92871L10.1475 11.6064L9.78613 12.3301H13.082L12.7207 11.6074L11.8818 9.92871L11.4346 9.03418L10.9873 9.92871Z" fill="#333333" stroke="#333333"/>
                                        </svg>
                                    </span>
                                    <span class="time">
                                        {{ item.time }}
                                    </span>
                                    <template #popper>
                                        {{ toLocal('mail.automatic_mail_tooltip') }}
                                    </template>
                                </VTooltip>
                                <div class="template-item" v-else>
                                    <span class="name" >
                                        {{ item.name }}
                                    </span>
                                    <span class="time">
                                        {{ item.time }}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="template-window" v-if="selectedTemplate">
            <div class="header">
                <div class="template-name" v-if="type=='templates'">
                    <input 
                    type="text"
                    v-model="selectedTemplate.name"
                    max-length="60"
                    >
                </div>
                <div class="sent-email-header" v-else>
                    <span class="name">
                        {{ selectedTemplate.name }}
                    </span>
                    <span class="date">
                        {{ selectedTemplate.date }}
                    </span>
                    <span class="divider">

                    </span>
                    <span class="time">
                        {{ selectedTemplate.time }}
                    </span>
                </div>
                <div class="right-side">
                    <div class="received-container" v-if="type=='sentMail'">
                        <font-awesome-icon v-if="sendingEmailsJob" icon="spinner" />
                        <span class="bold" v-if="sendingEmailsJob">
                            {{toLocal('generic.sending')}}: {{ (emailJob.totalUserCount - emailJob.usersSent.length) < 0 ? 0 : emailJob.totalUserCount - emailJob.usersSent.length }}
                        </span>
                        <span class="bold" v-else>
                            {{toLocal('generic.received')}}:
                        </span>
                        <span v-if="!sendingEmailsJob">
                            {{ filteredUsers.filter(el=>el.log && el.log.status && (el.log.status == 'sent')).length }}/{{ filteredUsers.length }}
                        </span>
                    </div>
                    <button @click="previewUsers">
                        {{toLocal('mail.view_recipients')}}
                    </button>                    
                </div>

            </div>
            <div class="content">
                <editor
                v-if="selectedTemplate"
                class="editor-parent-container"
                :item="item"
                :isEditing="type=='templates' ? true : false"
                :readOnly="type=='templates' ? false : true"
                v-model="selectedTemplate.mail_text"
            />
            </div>
            <div class="buttons" v-if="type=='templates'">
                <div
                    class="save--button"
                    @click="saveTemplate" 
                >
                    <span >
                        {{toLocal('mail.save_draft')}}
                        <svg v-if="!savingTemplate" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5603 3.75001L14.25 0.439695C14.1112 0.299801 13.946 0.188889 13.764 0.113407C13.582 0.0379245 13.3867 -0.000621974 13.1897 7.58902e-06H1.5C1.10218 7.58902e-06 0.720644 0.158043 0.43934 0.439347C0.158035 0.720652 0 1.10218 0 1.50001V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H16.5C16.8978 18 17.2794 17.842 17.5607 17.5607C17.842 17.2794 18 16.8978 18 16.5V4.81032C18.0006 4.61326 17.9621 4.41805 17.8866 4.23602C17.8111 4.054 17.7002 3.88879 17.5603 3.75001ZM12.75 16.5H5.25V11.25H12.75V16.5ZM16.5 16.5H14.25V11.25C14.25 10.8522 14.092 10.4707 13.8107 10.1893C13.5294 9.90804 13.1478 9.75001 12.75 9.75001H5.25C4.85218 9.75001 4.47064 9.90804 4.18934 10.1893C3.90804 10.4707 3.75 10.8522 3.75 11.25V16.5H1.5V1.50001H13.1897L16.5 4.81032V16.5ZM12 3.75001C12 3.94892 11.921 4.13969 11.7803 4.28034C11.6397 4.42099 11.4489 4.50001 11.25 4.50001H6C5.80109 4.50001 5.61032 4.42099 5.46967 4.28034C5.32902 4.13969 5.25 3.94892 5.25 3.75001C5.25 3.5511 5.32902 3.36033 5.46967 3.21968C5.61032 3.07903 5.80109 3.00001 6 3.00001H11.25C11.4489 3.00001 11.6397 3.07903 11.7803 3.21968C11.921 3.36033 12 3.5511 12 3.75001Z" fill="#404040"/>
                        </svg>
                        <font-awesome-icon icon="spinner" v-else />

                    </span>
                    
                </div>
                <button @click="sendEmails()" :class="{disabled: emailsSent}">
                    {{sendingEmails ? toLocal('users.invitations_sending') : emailsSent ? toLocal('emails.sent') : toLocal('generic.send_label')}}
                    <font-awesome-icon icon="spinner" v-if="sendingEmails" />
                </button>
            </div>
        </div>
        <portal to="user-list-drawer" >
            <UserDrawer 
            type="user_list_emails"
            ref="userListDrawer"
            :users="filteredUsers" 
            :usersType="'users'"  
            :sideOpen="showUsers"
            :options="{class: 'training-user-list', 'email_logs': type == 'sentMail', readOnly: selectedTemplate && selectedTemplate.id && (typeof selectedTemplate.id == 'string') && selectedTemplate.id.includes('auto') ? true : false}"
            @closeSide="showUsers = false"
            @resendEmails="resendEmails"
            @saveUserData="saveUserData($event)"
            />
        </portal>
        <GlobalModal
        v-if="publishTrainingModal.open"
        :modalInfo="{
            class: 'publish-training-modal'
        }"
        @onClose="publishTrainingModal.open = false"
        >
            <template v-slot:customContent>
                <h3 class="modal-title">
                    {{toLocal('emails.training_unpublished_label')}}
                </h3>
                <div class="button-container">
                    <button @click="sendEmails('send_published')">
                        {{toLocal('training.publish_and_send_email')}}
                    </button>
                    <button @click="sendEmails('send_unpublished')">
                        {{toLocal('training.send_email_wo_publish')}}
                    </button>
                    <button @click="$set(publishTrainingModal, 'open', false)">
                        {{toLocal('save_modal.cancel')}}
                    </button>
                </div>
            </template>
        </GlobalModal>
        <GlobalModal
        v-if="emailsSentModal.open"
        :modalInfo="{class: 'email-sent-info-modal'}"
        @onClose="closeEmailSentModal"
        >
            <template v-slot:customContent>
                <h3 class="modal-title">
                    {{toLocal('email.email_sent')}}
                </h3>
                <div class="button-container">
                    <button @click="$set(emailsSentModal, 'open', false);$emit('closeModal')">
                        {{toLocal('generic.close')}}
                    </button>
                </div>
            </template>
        </GlobalModal>
        <GlobalModal
        v-if="incorrectMailModalOpen"
        :modalInfo="{class: 'email-sent-info-modal'}"
        @onClose="incorrectMailModalOpen=false"
        >
            <template v-slot:customContent>
                <h3 class="medium-modal-title">
                    {{toLocal('emails.incorrect_emails_modal')}}
                </h3>
                <div class="button-container">
                    <button @click="incorrectMailModalOpen = false;sendEmails(null, true)">
                        {{ toLocal('emails.continue_sending') }}
                    </button>
                    <button @click="showUsers = true; incorrectMailModalOpen = false">
                        {{toLocal('emails.correct_receivers')}}
                    </button>
                </div>
            </template>
        </GlobalModal>
    </div>
</template>

<script>
import axios from "axios";
import TemplateItem from "./TemplateItem.vue";
import Editor from '@/components/layout/trainings/training_components/Editor.vue';
import UserDrawer from './UserDrawer.vue'
import GlobalModal from "@/components/layout/modals/GlobalModal.vue";
import { integer } from "vuelidate/lib/validators";

export default {
    props:{
        invitations: Array,
        item: Object,
        users: Array,
        type: String,
        editMode: {
            type: Boolean,
            default: false
        },
        sendEmailInvitationsModal: Object
    },
    components:{
        TemplateItem,
        UserDrawer,
        Editor,
        GlobalModal
    },
    watch:{
        searchInput(newValue){
            this.searchTemplates(newValue);
        },
        'selectedTemplate.id'(){
            if (this.selectedTemplate && this.selectedTemplate.mail_text && this.item && this.item.id) {
                this.selectedTemplate.mail_text = this.selectedTemplate.mail_text.replace(
                    /href="\/training\?id=\d+"/g,
                    `href="/training?id=${this.item.id}"`
                );
            }
        }
    },
    data(){
        return{
            templates: [],
            templatesCopy: [],
            searchInput: '',
            savingTemplate: false,
            selectedTemplate: null,
            item_type: 'training',
            loadingTemplates: false,
            defaultTemplate: {
                name: this.toLocal('emails.message_subject'),
                subject: this.toLocal('emails.message_subject'),
                mail_text: '',
                // mail_text: '<p>Tekstas:</p> <button-component href="/training?id="'+this.item.id+'" label="Eiti į mokymą"></button-component>',
                item_type: 'training',
                item_id: this.item.id,
                user_id: null
            },
            filteredUsers: [],
            showUsers: false,
            sentEmailTemplateList: [],
            sentDates: [],
            publishTrainingModal:{
                open: false
            },
            sendingEmails: false,
            sendingEmailsJob: false,
            emailJob:{
                totalUserCount: 0, //Total user count to send emails
                usersReceived: [], // Count of users that received emails
                usersSent: [], //Count of users that were sent emails
            },
            emailsSent: false,
            resentEmails: false,
            emailsSentModal:{
                open: false
            },
            allItemUsers: [],
            newInvitation: false,
            incorrectMailModalOpen: false,
        }
    },
    mounted(){
        this.defaultTemplate.mail_text = this.toLocal(this.$store.state.system_settings.defaultItemEmailTemplate);
        if(this.defaultTemplate.mail_text){
            this.defaultTemplate.mail_text = this.defaultTemplate.mail_text.replace('[training_id]', this.item.id);
        }
        if(this.type == 'templates'){
            this.selectedTemplate = this._.cloneDeep(this.defaultTemplate);
            this.getTemplates();
        }
        else{
            this.getSentEmails();
        }
        this.startEmailStatusEchoListen();
        if(this.type == 'sentMail'){
            
            this.getPreviewUsers(this.invitations[0]);
        }
    },
    beforeDestroy(){
        window.Echo.leave(`${this.$store.state.system_settings.lms_key}.${this.$store.state.user_id}.emailStatus`);
    },  
    methods:{
        startEmailStatusEchoListen() {
            window.Echo.private(
            `${this.$store.state.system_settings.lms_key}.emailStatus.${this.$store.state.user_id}`
            ).listen("SentEmailEvent", (e) => {
                let details = e.details;
                if(details.mail_status){
                    if(!this.emailJob.type ){
                        this.$set(this.emailJob, 'type', 'send');
                    }
                    if(this.emailJob.type == 'send'){
                        if(!this.sendingEmailsJob){
                            this.sendingEmailsJob = true;
                        }
                        if(!this.emailJob.totalUserCount)
                            this.emailJob.totalUserCount = this.filteredUsers.length;
                        this.emailJob.usersSent.push(details.user_id);
                    }
                    
                    this.sendingMailDebounce();
                    if(!this.emailJob.usersReceived.includes(details.user_id) && details.status == 'sent'){
                        this.emailJob.usersReceived.push(details.user_id);
                    }
                    let status_details = details.status_detail ? JSON.parse(details.status_detail) : null;
                    if(status_details && details.status){
                        if(details.status == 'sent'){
                            let index = this.filteredUsers.findIndex(el=>el.id == details.user_id);
                            if(index != -1) this.$set(this.filteredUsers[index].log,'status','sent');
                            if(this.$refs.userListDrawer && this.$refs.userListDrawer.sideUsers){
                                index = this.$refs.userListDrawer.sideUsers.findIndex(el=>el.id == details.user_id);
                                if(index != -1) this.$set(this.$refs.userListDrawer.sideUsers[index].log,'status', 'sent');
                            }
                        }
                        else{
                            if(this.$refs.userListDrawer && this.$refs.userListDrawer.sideUsers){
                                let index = this.$refs.userListDrawer.sideUsers.findIndex(el=>el.id == details.user_id);
                                if(index != -1) this.$set(this.$refs.userListDrawer.sideUsers[index].log,'status', details.status);
                            }
                        }
                    }
                }
                // else if(details.user_id){
                //     this.$set(this.emailJob, 'type', 'resend');
                //     if(!this.emailJob.usersSent.includes(details.user_id)){
                //         this.emailJob.usersSent.push(details.user_id);
                //     }
                // }
                if(details.job_status && details.job_status == 'finished'){
                    this.sendingEmailsJob = false;
                    // this.emailJob.totalUserCount = 0;
                    this.emailJob.usersSent = [];
                    this.$set(this.emailJob,'type',null);
                }
                if(details.job_status && details.job_status == 'started'){
                    this.sendingEmailsJob = true;
                }
            });
        },
        sendingMailDebounce: _.debounce(function () {
            this.sendingEmailsJob = false;
            this.emailJob.totalUserCount = 0;
            this.emailJob.usersSent = [];
            this.$set(this.emailJob,'type',null);
        },5000),
        getTemplates(){
            if(this.loadingTemplates) return;
            this.loadingTemplates= true;
            axios.get(
            `${this.$store.state.api_link}/email-template/items?item_type=${this.item_type}`,
            this.$store.getters.axiosConfig()
            )
            .then((response) => {
                this.templates = response.data
                this.templatesCopy = this._.cloneDeep(response.data)
                this.loadingTemplates = false;
                // this.selectedTemplate = this.templates[0];

            })
            .catch((err)=>{
                this.loadingTemplates = false;
            })
        },
        saveTemplate(action= null){
            if(this.savingTemplate) return;
            this.selectedTemplate.subject = this.selectedTemplate.name
            this.savingTemplate = true;
            axios.post(
            `${this.$store.state.api_link}/email-template/items?item_type=${this.item_type}`,
            {
                name: this.selectedTemplate.name,
                subject: this.selectedTemplate.subject,
                mail_text: this.selectedTemplate.mail_text,
                item_type: 'training',
                item_id: this.item.id,
                template_id: this.selectedTemplate.id
            },
            this.$store.getters.axiosConfig()
            )
            .then((response) => {
                this.savingTemplate = false;
                if(!this.selectedTemplate.id) {
                    this.templates.unshift(response.data);
                    this.templatesCopy.unshift(response.data);
                    this.selectedTemplate.id = response.data.id
                }
            
            })
            .catch((err)=>{
                this.savingTemplate = false;
            })
        },
        searchTemplates(searchInput){
            this.templates = this._.cloneDeep(this.templatesCopy);
            this.templates = this.templates.filter((el) => el.name.toLowerCase().includes(searchInput.toLowerCase()));
        },
        async sendEmails(action = null, confirmation=false){
            if(this.emailsSent) return;
            let invitation_ids = this.invitations.map((el) => el.id);
            this.sendingEmails = true;
            this.selectedTemplate.subject = this.selectedTemplate.name
            let email_data = null;
            if(this.sendEmailInvitationsModal){
                email_data = {
                    users: this.sendEmailInvitationsModal.tableData, 
                    training_id: this.sendEmailInvitationsModal.training_id,
                    category: this.sendEmailInvitationsModal.category.value,
                    time_type: this.sendEmailInvitationsModal.timeType.value,
                    time_quantity: this.sendEmailInvitationsModal.selectedTimeQuantity,
                    date: this.sendEmailInvitationsModal.date,
                }
                if(this.sendEmailInvitationsModal.userInvitations && this.sendEmailInvitationsModal.userInvitations.item){
                    email_data.invitation_id = this.sendEmailInvitationsModal.userInvitations.item.id
                }
            }
            if(this.filteredUsers.length == 0){
                await this.getLogUsers(false);
            }
            let filtered_emails = this.filteredUsers.filter((el) => !this.isValidEmail(el.email));
            if(filtered_emails.length > 0 && !confirmation){
                this.incorrectMailModalOpen = true;
                this.sendingEmails = false;
                return;
            }
            axios.post(
            `${this.$store.state.api_link}/email-template/items/send${action ? '?action='+action : ''}`,
            {
                template_id: this.selectedTemplate && this.selectedTemplate.id ? this.selectedTemplate.id : null,
                subject: this.selectedTemplate.subject,
                mail_text: this.selectedTemplate.mail_text,
                name: this.selectedTemplate.name,
                invitations: invitation_ids,
                training_id: this.item.id,
                email_data: email_data ? email_data : null
            },
            this.$store.getters.axiosConfig()
            )
            .then((response) => {
                if(response && response.data.send_type && response.data.send_type == 'ask_publish'){
                    this.$set(this.publishTrainingModal,'open', true);
                }
                else{
                    this.emailsSent =true
                    this.$set(this.emailsSentModal,'open', true);
                }
                this.sendingEmails = false;
                if(['send_published', 'send_unpublished'].includes(action)){
                    this.$set(this.publishTrainingModal,'open', false);
                    this.emailsSent =true
                    this.$set(this.emailsSentModal,'open', true);
                }
                setTimeout(() => {
                    this.emailsSent =false
                },3000)
               
                if(response.data.new_invitation){
                    this.$emit('addNewInvitation', response.data.new_invitation);
                    this.$emit('reloadUsers');
                    this.newInvitation = true;
                }

            })
            .catch((err)=>{
                this.sendingEmails = false;
            })
        },
        isValidEmail(email){
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
        },
        closeInvitationsModal(){
            this.sendEmailInvitationsModal.showInvitationSuccessModal = true;
            this.sendEmailInvitationsModal.sendingInvitations = false;
            this.sendEmailInvitationsModal.invitationStatusModal.loading = false;
            this.sendEmailInvitationsModal.$emit('close');
        },
        resendEmails(user_id, users){
            let user_ids = user_id == 'all' ? this.filteredUsers.filter(el=>el.log && el.log.status && (el.log.status != 'sent')).map(el=>el.id) : [user_id];
            let users_mapped = users.map((el) => {
                return {id: el.id, email: el.email}
            });
            axios.post(
            `${this.$store.state.api_link}/email-template/items/resend`,
            {
                template_log_id: this.selectedTemplate.id,
                user_ids: user_ids,
                users: users_mapped,
                training_id: this.item.id
            },
            this.$store.getters.axiosConfig()
            )
            .then((response) => {
                this.emailJob.totalUserCount = user_ids.length;
                this.$set(this.emailJob, 'type', 'resend');
                user_ids.forEach(id => {
                    let index = this.filteredUsers.findIndex(el=>el.id == id);
                    // if(index != -1) this.filteredUsers[index].log.status = 'sent';
                    index = this.$refs.userListDrawer.sideUsers.findIndex(el=>el.id == id);
                    if(index != -1) this.$set(this.$refs.userListDrawer.sideUsers[index].log,'status', 'sent');
                });
                if(user_id =='all'){
                    this.$set(this.$refs.userListDrawer,'sendingAll', false);
                }
                else{
                    let index = this.$refs.userListDrawer.sideUsers.findIndex(el=>el.id == user_id);
                    if(index != -1) this.$set(this.$refs.userListDrawer.sideUsers[index],'sending', false);
                }
                this.resentEmails=true;
            })
            .catch((err)=>{
                if(user_id =='all'){
                    this.$set(this.$refs.userListDrawer,'sendingAll', false);
                }
                else{
                    let index = this.$refs.userListDrawer.sideUsers.findIndex(el=>el.id == user_id);
                    if(index != -1) this.$set(this.$refs.userListDrawer.sideUsers[index],'sending', false);
                }
            })
        },
        getSentEmails(){
            axios.get(
            `${this.$store.state.api_link}/email-template/items/send/${this.invitations[0].id}`,
            this.$store.getters.axiosConfig()
            )
            .then((response) => {
                this.sentEmailTemplateList = response.data
                this.sentDates = response.data.reduce((acc, item) => {
                    (acc[item.date] = acc[item.date] || []).push(item);
                    return acc;
                }, {});
            })
            .catch((err)=>{
            })
        },
        async getLogUsers(openDrawer){ 
            let invitation_ids = this.invitations.map((el) => el.id);
            invitation_ids = invitation_ids.filter((el) => el != null && el != undefined);
            if(this.type == 'templates' && this.sendEmailInvitationsModal){
                let emails = this.invitations.map((el) => el.email);
                this.filteredUsers = this.users.filter((el) => {
                        return invitation_ids.includes(el.id) || emails.includes(el.email)
                });
                let mapped_ids = this.filteredUsers.map((el) => el.id);
                let mapped_emails = this.filteredUsers.map((el) => el.email);
                this.filteredUsers = this.invitations.map((el) => {
                    let index = mapped_ids.indexOf(el.id);
                    if(index != -1) return this.filteredUsers[index];
                    index = mapped_emails.indexOf(el.email);
                    if(index != -1) return this.filteredUsers[index];
                    return el;
                }); 
                this.showUsers = true;
            }
            else if(this.selectedTemplate.items){
                let user_ids = this.allItemUsers.map((el) => el.id);
                this.filteredUsers = this.users.filter((el) => user_ids.includes(el.id));
                this.filteredUsers = this.filteredUsers.map((val)=>{
                    let log_item = this.selectedTemplate.items.find((el) => el.recipient_id == val.id)
                    console.log(log_item)
                    if(log_item){
                        try {
                            log_item.delivery_details = log_item.delivery_details ? JSON.parse(log_item.delivery_details) : null;
                        } catch (e) {
                            log_item.delivery_details = null;
                        }
                        return {...val, log: log_item}
                    }
                    else{
                        return val;
                    }
                })
                this.filteredUsers.sort((a, b) => {
                    if (a.log && b.log) {
                        if(a.log.status == 'sent' && b.log.status != 'sent') return 1;
                        else return -1;
                    } else if (a.log) {
                        return -1;
                    } else if (b.log) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            }
            else{
                try{
                    let response = await axios.post(
                    `${this.$store.state.api_link}/email-template/items/preview/users`,
                    {
                        invitations: invitation_ids,
                        log_id: this.type == 'sentMail' ? this.selectedTemplate.id : null
                    },
                    this.$store.getters.axiosConfig()
                    )
                    let users_obj = response.data.users;
                    this.filteredUsers = this.users.filter((el) => users_obj[el.id]);
                    this.filteredUsers = this.filteredUsers.map((val)=>{
                        let log_item = users_obj[val.id]
                        return {...val, log: log_item}
                    })
                    this.filteredUsers.sort((a, b) => {
                        if (a.log && b.log) {
                            if(a.log.status == 'sent' && b.log.status != 'sent') return 1;
                            else return -1;
                        } else if (a.log) {
                            return -1;
                        } else if (b.log) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                    if(this.type == 'templates' && openDrawer) this.showUsers = true;
                }
                catch{

                }
            }
        },
        selectLog(item){
            this.selectedTemplate = item;
            this.getLogUsers()
        },
        async previewUsers(){
            
            if(this.type == 'templates') {
                await this.getLogUsers(true);
            }
            else{
                this.showUsers = true
                this.sortUsers();
            }
        },
        sortUsers(){
             this.filteredUsers.sort((a, b) => {
                if (a.log && b.log) {
                    if(a.log.status == 'sent' && b.log.status != 'sent') return 1;
                    else return -1;
                } else if (a.log) {
                    return -1;
                } else if (b.log) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        getPreviewUsers(invitation){
            
            axios.get(
                `${this.$store.state.api_link}/training/invitations/${invitation.id}/preview/users`,
                this.$store.getters.axiosConfig()
                )
                .then((res)=>{
                    this.allItemUsers = res.data.items
                })
                .catch((err)=>{

                })
        },
        duplicateTemplate(template){
            axios.post(
            `${this.$store.state.api_link}/email-template/items/duplicate`,
            {
                template_id: template.id,
            },
            this.$store.getters.axiosConfig()
            )
            .then((response) => {
                this.templates.unshift(response.data);
                this.templatesCopy.unshift(response.data);
            })
            .catch((err)=>{
            })
        },
        deleteTemplate(template){
            axios.delete(
            `${this.$store.state.api_link}/email-template/items/${template.id}`,
            this.$store.getters.axiosConfig()
            )
            .then((response) => {
                let index = this.templates.findIndex(el=>el.id == template.id);
                if(index != -1) this.templates.splice(index, 1);
                index = this.templatesCopy.findIndex(el=>el.id == template.id);
                if(index != -1) this.templatesCopy.splice(index, 1);
                if(this.selectedTemplate.id == template.id) this.selectedTemplate = null;
                if(this.templates.length == 0)  this.selectedTemplate = this._.cloneDeep(this.defaultTemplate);
            })
            .catch((err)=>{
            })
        },
        closeEmailSentModal(){
            this.$set(this.emailsSentModal, 'open', false);
            if(this.newInvitation) {
                this.$emit('closeModal');
            }
        },
        saveUserData(user){
            axios.post(
            `${this.$store.state.api_link}/user/save-data`,
            {
                user: user
            },
            this.$store.getters.axiosConfig()
            )
            .then((response) => {
                let index = this.filteredUsers.findIndex(el=>el.id == user.id);
                if(index != -1) this.$set(this.filteredUsers[index], 'email', user.email);
                this.$emit('saveUserData', user);
            })
            .catch((err)=>{
            })
        }
  
    }
}
</script>

<style lang="scss" scoped>
.send-emails-container{
    display: flex;
    width: 100%;
    height: 100%;
    padding: 42px;
}
.templates-container{
    display: flex;
    flex-direction: column;
    width: 35%;
    border: 2px solid #fff;
    border-radius: 20px;
    padding: 36px;
}
.search-container{
    grid-area: search;
    display: flex;
    align-items: center;
    background: white;
    border-radius: 2rem;
    color: var(--primary-color);
    padding: 0.25rem 0.5rem;
    .search-icon{
        display: flex;
        margin-right: 0.25rem;
        height: 100%;
        align-items: center;
        .remove{
            display: flex;
            position: relative;
            width: 1rem;
            height: 100%;
            cursor: pointer;
            transition: transform 0.3s;
            span{
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                width: 80%;
                height: 2px;
                background: var(--primary-color);
                border-radius: 1rem;
                transform: rotate(45deg);
            }
            span:last-child{
                transform: rotate(-45deg);
            }
            &:hover{
                transform: scale(1.1);
            }
        }
    }
    svg{
        path{
            fill: var(--primary-color);
        }
    }
    input{
        background: none;
        width: 100%;
        height: 100%;
        border: none;
        box-shadow: none;
        &:focus{
            outline: none;
        }
    }
}
.list{
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    text-align: left;
    gap: 12px;
    overflow: auto;
    max-height: 100%;
    height: 100%;
}
.buttons{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.right-side{
    display: flex;
    align-items: center;
    gap: 0.9rem;
    .bold{
        font-weight: 600;
        color: #333;
    }
    span{
        color:#757575;
    }
}
.save--button {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
      border: 1px solid var(--primary-color);
      padding: 7px 20px;
      border-radius: 10px;
      cursor: pointer;
      user-select: none;
      float: left;
      max-width: 430px;
      color: #333;
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 0;
      transition: background-color 0.3s, color 0.3s;
      span{
        display: flex;
        align-items: center;
        color:#333333;
        font-size: clamp(0.7rem, 1.2vw, 0.8rem);
        
      }
      svg{
        margin:0 15px;
        margin-right: 0;
        path{
        //   stroke: var(--primary-color);
        }
    }
    &:hover{
        background-color: #333;
        color: white;
        span{
            color: white;
        }
        svg{
            path{
                fill: white;
            }
        }
    }
}
.template-window{
    text-align: left;
    user-select: text;
}
.template-window{
    display: flex;
    flex-direction: column;
    width: 65%;
    gap: 0.75rem;
    margin-left: 1.7rem;
    .content{
        width: 100%;
        display: flex;
        height: 100%;
        max-height: 100%;
        overflow: auto;
    }
}
.header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2px;

}
.template-name{
    width: 60%;
}
.received-container{
    font-size: clamp(0.75rem, 1.15vw, 0.9rem);
}
.name{
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    svg{
        margin-top: 7px;
    }
}
.editor-parent-container{
    max-width: 100%;
}
input{
    background-color: #FFFFFF;
    border: none;
    border-bottom: 2px solid #E2E2E2;
    box-shadow: inset 0 2px 3px 0px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    font-size: 16px;
    padding: 6px 12px;
    width: 100%;
}
button{
    background-color: #E2E2E2;
    border-radius: 20px;
    display: flex;
    padding: 6px 13px;
    min-width: 98px;
    color:#333333;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.16);
    border: none;
    text-align: center;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: clamp(0.7rem, 1.2vw, 0.8rem);
    transition: background-color 0.3s;
    &:hover{
        background-color: #4D4D4D;
        color: white
    }
    &.disabled{
        cursor: not-allowed;
        opacity: 0.5;
        &:hover{
            background-color: #E2E2E2;
            color:#333333;
        }
    }
}
.sent-email-header{
    display: flex;
    align-items: center;
    gap: 12px;
    color: #333333;
    font-size: clamp(0.75rem, 1.15vw, 0.9rem);
    .date,.time{
        color:#757575;
    }
    .divider{
        height: 1.25rem;
        width: 1px;
        background-color: #B2B2B2;
    }
}
.sent-list{
    display: flex;
    flex-direction: column;
    text-align: left;
    font-weight: 600;
    max-height: 100%;
    overflow: auto;
    .date-item{
        display: flex;
        flex-direction: column;
        gap:8px;
        font-weight: 600;
    }
    .sent-template-container{
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .template-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
    .sent-template{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        background-color: white;
        border-radius: 8px;
        color: #333;
        padding: 8px;
        cursor: pointer;
        transition: background 0.3s;
        .tooltip-template-item-container{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        }
        &.active{
            background: #333;
            color: white;
            &:hover{
                background: #333;
            }
            .name{
                svg{
                    path{
                        fill: white;
                    }
                    .svg-triangle{
                        fill:#333;
                    }
                    .svg-letter{
                        stroke: white;
                    }
                }
            }
        }
        &:hover{
            background: #e2e2e2;
        }
    }
}
.dates{
    display: flex;
    flex-direction: column;
    gap: 1.1rem;
}
.modal-title{
    font-weight: 500;
    font-size: 1.6rem;
    margin: 0;
}
.medium-modal-title{
    font-weight: 500;
    font-size: 1rem;
    margin: 0;
    color: #333333;
}
.button-container{
    display: flex;
    align-items: center;
    gap: 1.1rem;
    margin-top: 3rem;
    button{
        width: 11.3rem;
        padding-top: 0.6rem;
        padding-bottom: 0.6rem;
    }
}
</style>